<template>
    <div id="config-settings">
        <div class="config-header">
            <div class="back">
                <router-link to="/home">
                    <font-awesome-icon icon="home" class="back-icon" />
                </router-link>
            </div>
        </div>
        <h2 class="title">Réglages</h2>
        <LoadingDots v-if="isLoading" />

        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Modules</h3>
                <div class="form-control">
                    <label>
                        Activer le module de validation
                        <Select
                            class="stretch setting-boolean"
                            name="mod_validation_enable"
                            placeholder="Faut-il activer le module de validation ?"
                            :options="mod_validation_enable"
                            :value="
                                mod_validation_enable.find(
                                    (e) => e.id === settings.mod_validation_enable,
                                )
                            "
                            @input="settings.mod_validation_enable = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Activer le module d'export
                        <Select
                            class="stretch setting-boolean"
                            name="mod_export_enable"
                            placeholder="Faut-il activer le module d'export ?"
                            :options="mod_export_enable"
                            :value="
                                mod_export_enable.find((e) => e.id === settings.mod_export_enable)
                            "
                            @input="settings.mod_export_enable = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Activer le module de rattachement
                        <Select
                            class="stretch setting-boolean"
                            name="mod_rattachment_enable"
                            placeholder="Faut-il activer le module de rattachement ?"
                            :options="mod_rattachment_enable"
                            :value="
                                mod_rattachment_enable.find(
                                    (e) => e.id === settings.mod_rattachment_enable,
                                )
                            "
                            @input="settings.mod_rattachment_enable = $event.id"
                        />
                    </label>
                </div>
            </div>
        </div>

        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Données OSM de référence</h3>

                <h4 class="subsection--title">Chargement osm2pgsql</h4>

                <div class="form-control">
                    <label>
                        Chemin et nom du fichier PBF des données OSM de référence à charger
                        <Input
                            class="stretch"
                            name="osm_pbffile"
                            placeholder="Renseignez le nom du fichier PBF des données de référence"
                            v-model="settings.osm_pbffile"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Chemin et nom du fichier POLY de découpe des données OSM de référence<br />
                        (Optionnel : pas de découpe si non renseigné)
                        <Input
                            class="stretch"
                            name="osm_polyfile"
                            placeholder="Renseignez le nom du fichier POLY de découpe"
                            v-model="settings.osm_polyfile"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Chemin et nom du fichier STYLE des données OSM de référence<br />
                        (Optionnel : utilisation de '/usr/share/osm2pgsql/default.style' si non
                        renseigné)
                        <Input
                            class="stretch"
                            name="osm_stylefile"
                            placeholder="Renseignez le nom du fichier STYLE des données de référence"
                            v-model="settings.osm_stylefile"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Système de coordonnées des données de référence après chargement (SRID)
                        <Input
                            class="stretch setting-number"
                            name="db_ref_srid"
                            placeholder="Renseignez un SRID"
                            v-model="settings.db_ref_srid"
                            type="number"
                            min="1"
                            max="999999"
                            step="1"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Schéma des tables des données de référence
                        <Input
                            class="stretch"
                            name="db_ref_schema"
                            placeholder="Renseignez le nom du schéma"
                            v-model="settings.db_ref_schema"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Préfixe des tables des données de référence<br />
                        (Sans le caractère '_' à la fin)
                        <Input
                            class="stretch"
                            name="db_ref_prefix"
                            placeholder="Renseignez un préfixe pour les tables"
                            v-model="settings.db_ref_prefix"
                            type="text"
                        />
                    </label>
                </div>

                <h4 class="subsection--title">Mise à jour</h4>

                <div class="form-control">
                    <label>
                        Mettre à jour les données de référence avec les données validées
                        <Select
                            class="stretch setting-boolean"
                            name="db_ref_update"
                            placeholder="Faut-il mettre à jour les données de référence ?"
                            :options="db_ref_update"
                            :value="db_ref_update.find((e) => e.id === settings.db_ref_update)"
                            @input="settings.db_ref_update = $event.id"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Données OSM d'itinéraire</h3>
                <h4 class="subsection--title">Chargement pgRouting</h4>

                <div class="form-control">
                    <label>
                        Chemin et nom du fichier MAPCONFIG utilisé par pgRouting
                        <Input
                            class="stretch"
                            name="osm_mapconfigfile"
                            placeholder="Renseignez le chemin et le nom du fichier mapconfig de pgRouting"
                            v-model="settings.osm_mapconfigfile"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Schéma des tables des données d'itinéraire
                        <Input
                            class="stretch"
                            name="db_pgr_schema"
                            placeholder="Renseignez un nom de schéma"
                            v-model="settings.db_pgr_schema"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Préfixe des tables des données d'itinéraire<br />
                        (Sans le caractère '_' à la fin)
                        <Input
                            class="stretch"
                            name="db_pgr_prefix"
                            placeholder="Renseignez un préfixe pour les tables"
                            v-model="settings.db_pgr_prefix"
                            type="text"
                        />
                    </label>
                </div>
                <h4 class="subsection--title">Mise à jour</h4>
                <div class="form-control">
                    <label>
                        Mettre à jour les données d'itinéraire avec les données validées
                        <Select
                            class="stretch setting-boolean"
                            name="db_pgr_update"
                            placeholder="Faut-il mettre à jour la base pgRouting ?"
                            :options="db_pgr_update"
                            :value="db_pgr_update.find((e) => e.id === settings.db_pgr_update)"
                            @input="settings.db_pgr_update = $event.id"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Données OSM à valider</h3>
                <h4 class="subsection--title">Géométrie</h4>
                <div class="form-control">
                    <label>
                        Tolérance de géométrie (0-100 en mètres)
                        <Input
                            class="stretch setting-number"
                            name="geom_tolerance"
                            placeholder="Renseignez une tolérance en mètres"
                            v-model="settings.geom_tolerance"
                            type="number"
                            min="0"
                            max="100"
                            step="0.1"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Charger les objets OSM de type node pour validation ?
                        <Select
                            class="stretch setting-boolean"
                            name="osm_diff_nodes_enable"
                            placeholder="Faut-il charger les nodes ?"
                            :options="osm_diff_nodes_enable"
                            :value="
                                osm_diff_nodes_enable.find(
                                    (e) => e.id === settings.osm_diff_nodes_enable,
                                )
                            "
                            @input="settings.osm_diff_nodes_enable = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Charger les objets OSM de type way pour validation ?
                        <Select
                            class="stretch setting-boolean"
                            name="osm_diff_ways_enable"
                            placeholder="Faut-il charger les ways ?"
                            :options="osm_diff_ways_enable"
                            :value="
                                osm_diff_ways_enable.find(
                                    (e) => e.id === settings.osm_diff_ways_enable,
                                )
                            "
                            @input="settings.osm_diff_ways_enable = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Charger les objets OSM de type relation pour validation ?
                        <Select
                            class="stretch setting-boolean"
                            name="osm_diff_relations_enable"
                            placeholder="Faut-il charger les relations ?"
                            :options="osm_diff_relations_enable"
                            :value="
                                osm_diff_relations_enable.find(
                                    (e) => e.id === settings.osm_diff_relations_enable,
                                )
                            "
                            @input="settings.osm_diff_relations_enable = $event.id"
                        />
                    </label>
                </div>
                <h4 class="subsection--title">API</h4>
                <div class="form-control">
                    <label>
                        URL de l'API Overpass
                        <Input
                            class="stretch"
                            name="osm_overpass_url"
                            placeholder="URL de l'API Overpass"
                            v-model="settings.osm_overpass_url"
                            type="url"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Paramètre "maxsize" de l'API Overpass
                        <Select
                            class="stretch setting-maxsize"
                            name="api_max_size"
                            placeholder="maxsize de l'API Overpass"
                            :options="api_max_size"
                            :value="api_max_size.find((e) => e.id === settings.api_max_size)"
                            @input="settings.api_max_size = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        URL de l'API OSM
                        <Input
                            class="stretch"
                            name="osm_api_url"
                            placeholder="URL de l'API OSM"
                            v-model="settings.osm_api_url"
                            type="url"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Carte</h3>
                <h4 class="subsection--title">Objets OSM</h4>
                <div class="form-control">
                    <label>
                        Nombre maximal d'objets affichés simultanément dans chaque groupe
                        d'objets<br />
                        <Input
                            class="stretch setting-number"
                            name="objects_limit"
                            placeholder="Renseignez un nombre entier"
                            v-model="settings.objects_limit"
                            type="number"
                            min="1"
                            step="1"
                            required="true"
                        />
                    </label>
                </div>
                <h4 class="subsection--title">Emprise géographique par défaut</h4>
                <div class="form-control">
                    <label>
                        Emprise par défaut (attention, seules les données OSM intersectant cette
                        emprise seront chargées en base)
                    </label>
                    <Select
                        class="stretch"
                        name="default_footprint"
                        :options="footprints"
                        :value="footprints.find((e) => e.id === settings.osm_footprint)"
                        @input="settings.osm_footprint = $event.id"
                    />
                </div>
                <div class="form-control">
                    <label>
                        Épaisseur du contour (0-10)
                        <Input
                            class="stretch setting-number"
                            name="osm_footprint_width"
                            placeholder="Épaisseur du contour de l'emprise"
                            v-model="settings.osm_footprint_width"
                            type="number"
                            min="0"
                            max="10"
                            step="0.1"
                            required="true"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Couleur de contour
                        <Input
                            class="stretch"
                            name="osm_footprint_pen_color"
                            placeholder="Couleur de contour de l'emprise"
                            v-model="settings.osm_footprint_pen_color"
                            type="color"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Opacité du contour (0-1)
                        <Input
                            class="stretch setting-number"
                            name="osm_footprint_pen_opacity"
                            placeholder="Opacité du contour de l'emprise"
                            v-model="settings.osm_footprint_pen_opacity"
                            type="number"
                            min="0"
                            max="1"
                            step="0.01"
                            required="true"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Couleur de remplissage
                        <Input
                            class="stretch"
                            name="osm_footprint_fill_color"
                            placeholder="Couleur de remplissage de l'emprise"
                            v-model="settings.osm_footprint_fill_color"
                            type="color"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Opacité du remplissage (0-1)
                        <Input
                            class="stretch setting-number"
                            name="osm_footprint_fill_opacity"
                            placeholder="Opacité du remplissage de l'emprise"
                            v-model="settings.osm_footprint_fill_opacity"
                            type="number"
                            min="0"
                            max="1"
                            step="0.01"
                            required="true"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Rétention des fichiers</h3>
                <div class="form-control">
                    <label>
                        Âge maximal des fichiers d'export (en jours)
                        <Input
                            class="stretch setting-number"
                            name="export_retention"
                            placeholder="Suppression des fichiers d'export datés de plus de n jours"
                            v-model="settings.export_retention"
                            type="number"
                            min="1"
                            max="365"
                            step="1"
                            required="true"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Âge maximal des fichiers journaux (en jours)
                        <Input
                            class="stretch setting-number"
                            name="log_retention"
                            placeholder="Suppression des fichiers journaux datés de plus de n jours"
                            v-model="settings.log_retention"
                            type="number"
                            min="1"
                            max="365"
                            step="1"
                            required="true"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Âge maximal des fichiers OSM (adiff et changeset, en jours)
                        <Input
                            class="stretch setting-number"
                            name="osm_retention"
                            placeholder="Suppression des fichiers OSM datés de plus de n jours"
                            v-model="settings.osm_retention"
                            type="number"
                            min="1"
                            max="365"
                            step="1"
                            required="true"
                        />
                    </label>
                </div>
            </div>
        </div>
        <div class="config-body" v-if="!isLoading">
            <div class="config-section">
                <h3 class="section--title">Serveur LDAP</h3>
                <div class="form-control">
                    <label>
                        Nom d'hôte
                        <Input
                            class="stretch"
                            name="ldap_host"
                            placeholder="Renseignez un nom d'hôte"
                            v-model="settings.ldap_host"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Port
                        <Input
                            class="stretch setting-number"
                            name="ldap_port"
                            placeholder="Renseignez un port"
                            v-model="settings.ldap_port"
                            type="number"
                            min="1"
                            max="65535"
                            step="1"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Chiffrement
                        <Select
                            class="stretch"
                            name="ldap_encrypt"
                            placeholder="Sélectionnez un chiffrement"
                            :options="ldap_encrypt"
                            :value="ldap_encrypt.find((e) => e.id === settings.ldap_encrypt)"
                            @input="settings.ldap_encrypt = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Le certificat du serveur (SSL/TLS) doit-il être valide ?
                        <Select
                            class="stretch setting-boolean"
                            name="ldap_cert_validity"
                            placeholder="Faut-il vérifier le certificat du serveur ?"
                            :options="ldap_cert_validity"
                            :value="
                                ldap_cert_validity.find((e) => e.id === settings.ldap_cert_validity)
                            "
                            @input="settings.ldap_cert_validity = $event.id"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        DN de l'utilisateur BIND
                        <Input
                            class="stretch"
                            name="ldap_bind_user"
                            placeholder="Renseignez un dn pour l'utilisateur BIND"
                            v-model="settings.ldap_bind_user"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Mot de passe de l'utilisateur BIND
                        <Input
                            class="stretch"
                            name="ldap_bind_password"
                            placeholder="Renseignez un mot de passe pour l'utilisateur BIND"
                            v-model="settings.ldap_bind_password"
                            type="password"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        DN de base
                        <Input
                            class="stretch"
                            name="ldap_base_dn"
                            placeholder="Renseignez un DN de base"
                            v-model="settings.ldap_base_dn"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Attribut login
                        <Input
                            class="stretch"
                            name="ldap_login_attribute"
                            placeholder="Renseignez un attribut de login"
                            v-model="settings.ldap_login_attribute"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Attribut mot de passe
                        <Input
                            class="stretch"
                            name="ldap_password_attribute"
                            placeholder="Renseignez un attribut de mot de passe"
                            v-model="settings.ldap_password_attribute"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Attribut prénom
                        <Input
                            class="stretch"
                            name="ldap_firstname_attribute"
                            placeholder="Renseignez un attribut de prénom"
                            v-model="settings.ldap_firstname_attribute"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Attribut nom
                        <Input
                            class="stretch"
                            name="ldap_lastname_attribute"
                            placeholder="Renseignez un attribut de nom"
                            v-model="settings.ldap_lastname_attribute"
                            type="text"
                        />
                    </label>
                </div>
                <div class="form-control">
                    <label>
                        Attribut email
                        <Input
                            class="stretch"
                            name="ldap_email_attribute"
                            placeholder="Renseignez un attribut d'email"
                            v-model="settings.ldap_email_attribute"
                            type="text"
                        />
                    </label>
                </div>
            </div>
        </div>

        <div class="config-section mt-5" v-if="!isLoading">
            <div class="form-control form-inline">
                <Button class="stretch" @click="handleReload">Annuler</Button>
                <Button class="default stretch" @click="handleSave">Enregistrer</Button>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';
import Input from '@/components/Input';
import Select from '@/components/Select';
import Button from '@/components/Button';

export default {
    data() {
        return {
            isLoading: true,
            settings: {
                db_ref_update: null,
                db_ref_srid: null,
                db_ref_schema: null,
                db_ref_prefix: null,
                db_pgr_update: null,
                db_pgr_schema: null,
                db_pgr_prefix: null,
                osm_diff_nodes_enable: null,
                osm_diff_ways_enable: null,
                osm_diff_relations_enable: null,
                osm_mapconfigfile: null,
                osm_pbffile: null,
                osm_polyfile: null,
                osm_stylefile: null,
                geom_tolerance: null,
                osm_footprint: null,
                osm_footprint_pen_color: null,
                osm_footprint_pen_opacity: null,
                osm_footprint_fill_color: null,
                osm_footprint_fill_opacity: null,
                osm_footprint_width: null,
                osm_overpass_url: null,
                osm_api_url: null,
                objects_limit: null,
                export_retention: null,
                log_retention: null,
                osm_retention: null,
                ldap_host: null,
                ldap_port: null,
                ldap_encrypt: null,
                ldap_cert_validity: null,
                ldap_bind_user: null,
                ldap_bind_password: null,
                ldap_base_dn: null,
                ldap_login_attribute: null,
                ldap_password_attribute: null,
                ldap_firstname_attribute: null,
                ldap_lastname_attribute: null,
                ldap_email_attribute: null,
                api_max_size: null,
                mod_validation_enable: null,
                mod_export_enable: null,
                mod_rattachment_enable: null,
            },
            loaded_settings: [],
            ldap_encrypt: [{ id: 'none', text: 'Aucun' }, { id: 'TLS', text: 'SSL/TLS' }],
            db_ref_update: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            db_pgr_update: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            osm_diff_nodes_enable: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            osm_diff_ways_enable: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            osm_diff_relations_enable: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            mod_validation_enable: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            mod_export_enable: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            mod_rattachment_enable: [{ id: '0', text: 'Non' }, { id: '1', text: 'Oui' }],
            ldap_cert_validity: [{ id: 'false', text: 'Non' }, { id: 'true', text: 'Oui' }],
            api_max_size: [
                { id: '134217728', text: '128Mo' },
                { id: '268435456', text: '256Mo' },
                { id: '536870912', text: '512Mo' },
                { id: '1073741824', text: '1Go' },
                { id: '2147483648', text: '2Go' },
            ],
            footprints: [],
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.isLoading = true;
            this.loadFootprints().then(() => {
                this.$http
                    .get('/api/setting')
                    .then(
                        (response) => {
                            const settings = response.body;
                            this.loaded_settings = settings;
                            settings.forEach((s) => (this.settings[s.name] = s.value));
                        },
                        (response) => {
                            // error callback
                            console.log(JSON.stringify(response));
                        },
                    )
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },
        handleReload() {
            this.isLoading = true;
            this.loadSettings();
        },
        handleSave() {
            // handle create or update setting
            const settings = Object.entries(this.settings).map(([k, v]) => {
                const loaded = this.loaded_settings.find((s) => s.name === k);
                if (loaded && loaded.value !== v) {
                    // update loaded setting
                    return this.$http.put(`/api/setting/${loaded.id}`, { ...loaded, value: v });
                }
                if (!loaded && v) {
                    // create new setting
                    return this.$http.post('/api/setting', { name: k, value: v });
                }
                return null;
            });
            Promise.all(settings.filter((s) => s)).then(
                (responses) => {
                    responses.forEach((r) => {
                        const setting = r.body;
                        const index = this.loaded_settings.findIndex((s) => s.id === setting.id);
                        index > -1
                            ? this.loaded_settings.splice(index, 1, setting)
                            : this.loaded_settings.push(setting);
                    });
                },
                (err) => console.log(JSON.stringify(err)),
            );
        },
        loadFootprints() {
            return new Promise((resolve, reject) => {
                this.footprints = [];
                this.$http.get('/api/footprint').then(
                    (response) => {
                        // success callback
                        if (response.body.length) {
                            for (let i = 0; i < response.body.length; i++) {
                                const footprint = response.body[i];
                                this.footprints.push({
                                    id: String(footprint.id),
                                    text: footprint.name,
                                });
                            }
                        }
                        resolve();
                    },
                    (response) => {
                        // error callback
                        console.error(response);
                        reject();
                    },
                );
            });
        },
    },
    components: {
        LoadingDots,
        Input,
        Select,
        Button,
    },
};
</script>

<style lang="scss">
.config-header {
    height: 50px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;

    .back {
        box-sizing: border-box;
        width: 50px;
        opacity: 0.5;
        box-shadow: 2px 0 4px 2px rgba(212, 216, 221, 0.43);
        display: flex;
        align-items: center;
        justify-content: center;

        .back-icon {
            width: 25px;
            height: 25px;
            color: #8e919b;
        }
    }
}
.config-body {
    margin: 25px 30px;
    padding: 20px 0;
    border: 1px solid #9ca5b0;
    border-radius: 5px;
    border-top: 5px solid #6c3e91;
    background-color: #ffffff;

    .config-section {
        width: 50%;
        h3.section--title {
            // margin-left: 35px;
            margin: 5px 35px 20px;
            padding-bottom: 5px;
            font-size: 2em;
            font-weight: 600;
            text-transform: uppercase;
            border-bottom: 3px solid black;
        }
        h4.subsection--title {
            margin: 5px 35px 20px;
            padding-top: 5px;
            padding-bottom: 5px;
            font-size: 1.5em;
            font-weight: 400;
            border-bottom: 1.5px solid grey;
        }
    }

    .mt-5 {
        margin-top: 5em;
    }
}
.setting-boolean,
.setting-number {
    max-width: 90px;
}
.setting-maxsize {
    max-width: 120px;
}
label {
    font-size: 1em !important;
}
</style>
